module.exports = lib_eui_icons;